<fu-period-calendar
  labelSize="m"
  [label]="label()"
  [maxDate]="maxDate()"
  [minDate]="minDate()"
  [formControl]="control()"
  [useExternalIcons]="true"
  [disableManualEditing]="true"
  [placeholder]="placeholder()"
  [useOutlineLabel]="useOutlineLabel()"
  [leftMonthToShowByDefault]="leftMonthToShowByDefault()"
/>
